import React from "react";
import { createRoot } from "react-dom/client";
import { StyledEngineProvider } from "@mui/material/styles";
import { CssBaseline, GlobalStyles } from "@mui/material";
import App from "./App";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <CssBaseline />
     <GlobalStyles
  styles={{
    "*, *::before, *::after": { boxSizing: "border-box" },
    html: { height: "100%" },
    body: {
      minHeight: "100%",
      margin: 0,
      padding: 0,
      // ЕДИНЫЙ фон для всего сайта (и Navbar, и Home, и других страниц)
      background:
        "radial-gradient(circle at top, rgba(198,186,255,.28), transparent 55%), #020617",
      color: "#e5e7eb",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    "#root": { minHeight: "100%" },
  }}
/>


      <App />
    </StyledEngineProvider>
  </React.StrictMode>
);
